/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    DeletedFilesInfoResponseDTO,
    FileObjectResponseDTO,
    FilePropResponseDTO,
    GetRequestJobsDeletedFilesInfoByJobUuidParams,
    GetRequestJobsFileExistsByChecksumByJobUuidAndChecksum200,
    GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    GetRequestJobsFilesByJobUuidParams,
    GetRequestJobsFilesExistsByChecksumByJobUuid200,
    GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    GetRequestJobsMetadataByJobUuidAndFileUuid200,
    GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    HTTPValidationErrorDTO,
    PostRequestJobsFilesByUuidByJobUuidParams,
    PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    SupportedExtensionsResponseDTO,
    VideoTranscodingResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * This call returns the metadata of the specified file. The returned
json object includes the standard Photo/Image exif fields of the image
without the entire namespace tree.
If it is called without the optional *full* argument it returns an
object which may include the following tags

* Make
* Model
* ApertureValue
* ExposureTime
* FocalLength
* ISOSpeedRatings
* Capture.GpsPosition
* Capture.Country
* Capture.Municipality

There are capturized custom tags which are created for convenience
reasons. These are added into *Capture* namespace and are the
following

* Capture.Parser
* Capture.OrigWidth
* Capture.OrigHeight
* Capture.GpsPosition

The *Capture.GpsPosition* is provided as a three-elements float list
where indexes represent the *longitude*, *latitude* and *altitude*
coordinates correspondingly.

*NOTE* that this call could take long if the metadata is not in cache
or if it hasn't been acquired yet (e.g. files already uploaded) since
the for grabbing the metadata the original file must be fetched and
processed.

 * @summary Get File Metadata
 */
export const getRequestJobsMetadataByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestJobsMetadataByJobUuidAndFileUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/metadata/${encodeURIComponent(String(fileUuid))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsMetadataByJobUuidAndFileUuidQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    params?: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/metadata/${fileUuid}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsMetadataByJobUuidAndFileUuidQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsMetadataByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsMetadataByJobUuidAndFileUuidQueryKey(
            jobUuid,
            fileUuid,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>>
    > = ({ signal }) =>
        getRequestJobsMetadataByJobUuidAndFileUuid(
            jobUuid,
            fileUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && fileUuid),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsMetadataByJobUuidAndFileUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>>
>
export type GetRequestJobsMetadataByJobUuidAndFileUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsMetadataByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsMetadataByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsMetadataByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsMetadataByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsMetadataByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsMetadataByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsMetadataByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsMetadataByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsMetadataByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsMetadataByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get File Metadata
 */

export function useGetRequestJobsMetadataByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsMetadataByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsMetadataByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsMetadataByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsMetadataByJobUuidAndFileUuidQueryOptions(
            jobUuid,
            fileUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Lists files for a specific job that can be used in following ways:
- If _path_ parameter specified every files in the directory will be returned (excluding paths from subdirectories) for the job. The query can be combined with _dirs_only_, _recursive_ or file filters such as  _file_type_filters_, __uploaded_since__ or __reaction__ parameters to reduce or extend the files to be returned. If _dirs_only_ specified  any value in file filters will be ignored.
- If _path_ is not provided it returns all files belonging to the job. The returned files may be limited with _dirs_only_, _start_, _end_ or file filters query arguments. The _recursive_ parameter will be ignored if provided.

 * @summary Get Job Files
 */
export const getRequestJobsFilesByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FileObjectResponseDTO[]>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsFilesByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/files`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsFilesByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesByJobUuid(jobUuid, params, requestOptions, signal)

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>
>
export type GetRequestJobsFilesByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Job Files
 */

export function useGetRequestJobsFilesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsFilesByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * List with deleted file information

 * @summary Get Deleted Files Info
 */
export const getRequestJobsDeletedFilesInfoByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DeletedFilesInfoResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/deleted_files_info`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsDeletedFilesInfoByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsDeletedFilesInfoByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/deleted_files_info`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsDeletedFilesInfoByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsDeletedFilesInfoByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsDeletedFilesInfoByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsDeletedFilesInfoByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>
>
export type GetRequestJobsDeletedFilesInfoByJobUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsDeletedFilesInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsDeletedFilesInfoByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsDeletedFilesInfoByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsDeletedFilesInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsDeletedFilesInfoByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsDeletedFilesInfoByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsDeletedFilesInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Deleted Files Info
 */

export function useGetRequestJobsDeletedFilesInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsDeletedFilesInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsDeletedFilesInfoByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsDeletedFilesInfoByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Set properties of a file.
Is currently used to set info on the grouping of a live/burst photo,
but may be extended in the future to support more properties.

 * @summary Post File Props
 */
export const postRequestJobsFilesPropertiesByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files/${encodeURIComponent(String(fileUuid))}/properties`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesPropertiesByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestJobsFilesPropertiesByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return postRequestJobsFilesPropertiesByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsFilesPropertiesByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestJobsFilesPropertiesByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post File Props
 */
export const usePostRequestJobsFilesPropertiesByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestJobsFilesPropertiesByJobUuidAndFileUuid>
    >,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: PostRequestJobsFilesPropertiesByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesPropertiesByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the properties that are set on a file.

Is currently used to return info on the grouping of a live/burst photo,
but may be extended in the future to support more properties.

 * @summary Get File Props
 */
export const getRequestJobsFilesPropertiesByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FilePropResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files/${encodeURIComponent(String(fileUuid))}/properties`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    params?: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/files/${fileUuid}/properties`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
        >,
        TError = ErrorType<void | HTTPValidationErrorDTO>,
    >(
        jobUuid: string,
        fileUuid: string,
        params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryKey(
                jobUuid,
                fileUuid,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                >
            >
        > = ({ signal }) =>
            getRequestJobsFilesPropertiesByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!(jobUuid && fileUuid),
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
        >
    >
export type GetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesPropertiesByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesPropertiesByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesPropertiesByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get File Props
 */

export function useGetRequestJobsFilesPropertiesByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsFilesPropertiesByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesPropertiesByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsFilesPropertiesByJobUuidAndFileUuidQueryOptions(
            jobUuid,
            fileUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Check if a file exists in a job

 * @summary Get File Exists By Checksum Handler
 */
export const getRequestJobsFileExistsByChecksumByJobUuidAndChecksum = (
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestJobsFileExistsByChecksumByJobUuidAndChecksum200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/file_exists_by_checksum/${encodeURIComponent(String(checksum))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryKey =
    (
        jobUuid?: string,
        checksum?: string,
        params?: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    ) => {
        return [
            `/jobs/${jobUuid}/file_exists_by_checksum/${checksum}`,
            ...(params ? [params] : []),
        ] as const
    }

export const getGetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
            >
        >,
        TError = ErrorType<void | HTTPValidationErrorDTO>,
    >(
        jobUuid: string,
        checksum: string,
        params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryKey(
                jobUuid,
                checksum,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                >
            >
        > = ({ signal }) =>
            getRequestJobsFileExistsByChecksumByJobUuidAndChecksum(
                jobUuid,
                checksum,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!(jobUuid && checksum),
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
            >
        >
    >
export type GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFileExistsByChecksumByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFileExistsByChecksumByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFileExistsByChecksumByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get File Exists By Checksum Handler
 */

export function useGetRequestJobsFileExistsByChecksumByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsFileExistsByChecksumByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFileExistsByChecksumByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsFileExistsByChecksumByJobUuidAndChecksumQueryOptions(
            jobUuid,
            checksum,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Check if files belong in a job

 * @summary Get Files Exists By Checksum Handler
 */
export const getRequestJobsFilesExistsByChecksumByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestJobsFilesExistsByChecksumByJobUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_exists_by_checksum`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesExistsByChecksumByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/files_exists_by_checksum`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsFilesExistsByChecksumByJobUuidQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesExistsByChecksumByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesExistsByChecksumByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesExistsByChecksumByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesExistsByChecksumByJobUuidQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>>
    >
export type GetRequestJobsFilesExistsByChecksumByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesExistsByChecksumByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesExistsByChecksumByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesExistsByChecksumByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesExistsByChecksumByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesExistsByChecksumByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesExistsByChecksumByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesExistsByChecksumByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsFilesExistsByChecksumByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesExistsByChecksumByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesExistsByChecksumByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Files Exists By Checksum Handler
 */

export function useGetRequestJobsFilesExistsByChecksumByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsFilesExistsByChecksumByJobUuid>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesExistsByChecksumByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsFilesExistsByChecksumByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsFilesExistsByChecksumByJobUuidQueryOptions(
            jobUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Get Supported Extensions
 */
export const getRequestSupportedExtensions = (
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SupportedExtensionsResponseDTO>(
        { url: `/supported_extensions`, method: 'GET', signal },
        options,
    )
}

export const getGetRequestSupportedExtensionsQueryKey = () => {
    return [`/supported_extensions`] as const
}

export const getGetRequestSupportedExtensionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
            TError,
            TData
        >
    >
    request?: SecondParameter<typeof customInstance>
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestSupportedExtensionsQueryKey()

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestSupportedExtensions>>
    > = ({ signal }) => getRequestSupportedExtensions(requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestSupportedExtensionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestSupportedExtensions>>
>
export type GetRequestSupportedExtensionsQueryError = ErrorType<unknown>

export function useGetRequestSupportedExtensions<
    TData = Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestSupportedExtensions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestSupportedExtensions<
    TData = Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestSupportedExtensions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestSupportedExtensions<
    TData = Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Supported Extensions
 */

export function useGetRequestSupportedExtensions<
    TData = Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestSupportedExtensions>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestSupportedExtensionsQueryOptions(options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Lists files given by uuid for a specific job. The returned files 
may be reduced with file filters such as _file_type_filters_, 
_uploaded_since_ or _reaction_ parameters

 * @summary Post Files By Uuid
 */
export const postRequestJobsFilesByUuidByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsFilesByUuidByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FileObjectResponseDTO[]>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_uuid`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesByUuidByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsFilesByUuidByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsFilesByUuidByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsFilesByUuidByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsFilesByUuidByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsFilesByUuidByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsFilesByUuidByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>
>

export type PostRequestJobsFilesByUuidByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Files By Uuid
 */
export const usePostRequestJobsFilesByUuidByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsFilesByUuidByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsFilesByUuidByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsFilesByUuidByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesByUuidByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Video Transcoding Url
 */
export const getRequestJobsVideoUrlByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<VideoTranscodingResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/video_url/${encodeURIComponent(String(fileUuid))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsVideoUrlByJobUuidAndFileUuidQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    params?: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/video_url/${fileUuid}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsVideoUrlByJobUuidAndFileUuidQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsVideoUrlByJobUuidAndFileUuidQueryKey(
            jobUuid,
            fileUuid,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>>
    > = ({ signal }) =>
        getRequestJobsVideoUrlByJobUuidAndFileUuid(
            jobUuid,
            fileUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && fileUuid),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsVideoUrlByJobUuidAndFileUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>>
>
export type GetRequestJobsVideoUrlByJobUuidAndFileUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsVideoUrlByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsVideoUrlByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsVideoUrlByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Video Transcoding Url
 */

export function useGetRequestJobsVideoUrlByJobUuidAndFileUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsVideoUrlByJobUuidAndFileUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    params: GetRequestJobsVideoUrlByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsVideoUrlByJobUuidAndFileUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsVideoUrlByJobUuidAndFileUuidQueryOptions(
            jobUuid,
            fileUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
